/** The two-letter stand-in an avatar with no image falls back to. */
export function initials(name: string | null): string {
  const [first, second] = (name ?? '').trim().split(/\s+/);
  return ((first?.[0] ?? '') + (second?.[0] ?? '')).toUpperCase();
}
